import { logD, logE } from "@blacknut/logging/dist";
import { WebSocketClient } from "./WebSocketClient";

interface WebSocketManagerOption {
  onOpen: (client: WebSocketClient) => void;
  onClose: (client: WebSocketClient) => void;
  onMessage: (event: MessageEvent) => void;
  url: string;
}
const LOGGING_TAG = "Input";
export declare type KeyboardPayload = {
  event: {
    sc: number;
    pr?: string;
  };
};
export class WebSocketManager {
  public webSocketInput?: WebSocketClient;

  constructor(options: WebSocketManagerOption) {
    const { url } = options;
    this.webSocketInput = new WebSocketClient({
      url,
      namespace: "input",
      ...options,
    });
  }

  getLoggingTag() {
    return `${this.webSocketInput?.id}`;
  }

  stop(reconnect: boolean) {
    logD(
      this.getLoggingTag(),
      "Closing input socket %o (can reconnect: %o)",
      this.webSocketInput.id,
      reconnect,
    );
    if (this.webSocketInput) {
      this.webSocketInput.stop(reconnect);
      this.webSocketInput = undefined;
    } else {
      logD(LOGGING_TAG, "No ws available");
    }
  }

  createGamepadSocket(index: number, payload: any) {
    return this.sendDataGamepad(index, "OPEN;;", payload);
  }
  closeGamepadSocket(index: number) {
    this.sendDataGamepad(index, "CLOSED;;");
  }

  sendData(device: string, data: string, payload?: any) {
    if (this.webSocketInput) {
      let json = "";
      if (typeof payload !== "undefined") {
        json = JSON.stringify({
          device: device,
          json_data: data,
          payload: payload,
        });
      } else {
        json = JSON.stringify({ device: device, json_data: data });
      }
      return this.webSocketInput.sendData(json);
    } else {
      logE(
        this.getLoggingTag(),
        "Error sending data (%o:%o:%o): socket closed",
        device,
        data,
        payload,
      );
      return false;
    }
  }

  sendDataGamepad(index: number, data: string, payload?: any) {
    return this.sendData(`gamepad${index + 1}`, data, payload);
  }
  sendDataMouse(data: string) {
    this.sendData(`mouse`, data);
  }
  sendDataTouch(data: string) {
    this.sendData(`touch`, data);
  }
  sendDataKeyboard(data: string, payload?: KeyboardPayload) {
    this.sendData(`keyboard`, data, payload);
  }
  public sendDataRemote(data) {
    this.sendData(`remote`, data);
  }

  sendDataUnicode(_index: number, data: string) {
    let buffer = "";
    for (let i = 0; i < data.length; i++) {
      const formatted = data.charCodeAt(i).toString(16).padStart(4, "0");
      buffer += `u_${formatted};`;
    }
    this.sendData(`unicode`, buffer);
  }
}
